export default __webpack_public_path__ + "static/media/step-two.738224de.png";